<template>
    <div class="testimonial-view" v-loading="loading">
        <div class="row">

            <div class="col-md-4 mb-2">

                <el-form ref="switchOption" :model="switchOption" label-width="150px" v-if="rights.switch">
                    <el-form-item label="Testimonial :">
                        <el-switch
                            v-model="switchOption.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="Enable"
                            inactive-text="Disable"
                            @change= "changeDisplayStatus"
                            :disabled = "switchOption.disabled">
                        </el-switch>
                    </el-form-item>
                </el-form>

            </div>

            <div class="col-md-4 mb-2">
                <el-button type="primary" @click="blukDelete" v-if="rights.delete">Bulk Delete</el-button>
                <el-button type="primary" @click="page.openDialog = true" v-if="rights.add">Add Testimonial</el-button>

                <el-dialog
                    title="Testimonial"
                    :visible.sync="page.openDialog"
                    width="50%"
                    :before-close="handleDialogClose"
                    v-loading="page.dialogLoding">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">

                                <el-form ref="testimonialForm" :model="page.form" :rules="page.formRules" label-width="150px">

                                    <el-form-item label="Name" prop="name">
                                        <el-input v-model="page.form.name" ref="name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Testimonial" prop="testimonial">
                                        <el-input type="textarea" v-model="page.form.testimonial" ref="testimonial"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Rate" prop="rate">
                                        <el-rate v-model="page.form.rate" ref="rate"></el-rate>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="submitData" v-if="page.formBtnSubmit">Submit</el-button>
                                        <el-button type="primary" @click="resetData('testimonialForm')" v-if="page.formBtnSubmit">Reset</el-button>
                                        <el-button type="primary" @click="updateData" v-if="page.formBtnUpdate">Update</el-button>
                                    </el-form-item>

                                </el-form>

                            </div>
                        </div>

                    </span>
                </el-dialog>
            </div>

            <div class="col-md-4 mb-2">
                <el-input v-model="table.search" placeholder="Search By Name" v-if="rights.view" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="table.tableData.filter(data => !table.search || data.name.toLowerCase().includes(table.search.toLowerCase()))"
                    :default-sort = "{prop: 'enquiry_date', order: 'descending'}"
                    style="width: 100%"
                    v-loading="table.loading"
                    @selection-change="handleSelectionChange"
                    v-if="rights.view">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="Name" prop="name" sortable> </el-table-column>
                    <el-table-column label="Testimonial" prop="testimonial"> </el-table-column>
                    <el-table-column label="Rate" prop="rate" sortable> </el-table-column>

                    <el-table-column
                        v-if="rights.edit || rights.delete"
                        align="right">
                        <template slot="header" slot-scope="scope">
                            Action
                        </template>
                        <template slot-scope="scope">
                            <el-button
                            v-if="rights.edit"
                            size="mini"
                            @click="handleEditClick(scope.$index, scope.row)">Edit</el-button>
                            <el-button
                            v-if="rights.delete"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="pagination.perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
export default {
    data () {

        const validName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the name'))
            } else {
                callback()
            }
        }
        const validTestimonial = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Testimonial'))
            } else {
                callback()
            }
        }
        const validRate = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Plase Give rate'))
            } else {
                callback()
            }
        }

        return {
            loading: true,
            rights: {
                page: true,
                view: false,
                add: false,
                edit: false,
                delete: false,
                bulk_delete: false,
                switch: false,

            },
            switchOption: {
                disabled: false,
                status: true,
                cs_id: 0
            },
            page: {
                openDialog: false,
                dialogLoding: false,
                form: {
                    t_id: 0,
                    name: '',
                    testimonial: '',
                    rate: null,
                },
                formRules: {
                    name: [{ required: true, trigger: 'blur', validator: validName }],
                    testimonial: [{ required: true, trigger: 'blur', validator: validTestimonial }],
                    rate: [{ required: true, trigger: 'blur', validator: validRate }]
                },
                formBtnSubmit: true,
                formBtnUpdate: false,
                formValid: false
            },
            table: {
                search: '',
                loading: true,
                multipleSelection: [],
                tableData: []
            },
            pagination: {
                currentPage: 1,
                perPageItem: 100,
                totalData: 0
            }
        }
    },
    methods: {
        //Dialog Close Event
        handleDialogClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                this.resetData('testimonialForm')
                done();
            })
            .catch(_ => {});
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true
                }
                else{
                    this.page.formValid = false
                }
            });
        },
        //Page Size
        handleSizeChange(val) {
            this.pagination.perPageItem = val
            this.getData()
        },
        //Current Page
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getData()
        },
        //Multi Select
        handleSelectionChange(val){
            this.table.multipleSelection = val
        },
        //Single row Edit
        handleEditClick(index, row) {
            this.page.form.t_id = row.t_id
            this.page.form.name = row.name
            this.page.form.testimonial = row.testimonial
            this.page.form.rate = parseInt(row.rate)

            this.page.formBtnSubmit = false
            this.page.formBtnUpdate = true

            this.page.openDialog = true
        },
        getRights() {
            this.loading = true
            this.$axios.post('testimonial/rights.php' , {} , {
                headers: generateHeader("testimonialRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.testimonial_page == 1 ? true : false
                    // Rights
                    this.rights.add = response.data.body.rights.testimonial_add == 1 ? true : false
                    this.rights.view = response.data.body.rights.testimonial_view == 1 ? true : false
                    this.rights.edit = response.data.body.rights.testimonial_edit == 1 ? true : false
                    this.rights.delete = response.data.body.rights.testimonial_delete == 1 ? true : false
                    this.rights.bulk_delete = response.data.body.rights.testimonial_bulk_delete == 1 ? true : false
                    this.rights.switch = response.data.body.rights.testimonial_switch == 1 ? true : false

                    // switchOption Value
                    this.switchOption.status = response.data.body.switchValue.status == 1 ? true : false
                    this.switchOption.cs_id = response.data.body.switchValue.cs_id

                    this.getData();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        //Main Display
        //Content Display Setting using switch
        changeDisplayStatus(){
            this.$axios.post('testimonial/displaySwitch.php' , {
                status: this.switchOption.status,
                cs_id: this.switchOption.cs_id
            }, {
                headers: generateHeader("testimonialSwitch")
            })
            .then((response) => {
                if(response.data.code == "204"){
                    this.switchOption.disabled = true
                    setTimeout(() => this.switchOption.disabled = false, 1000);
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
            })
        },
        getData() {
            this.table.loading = true
            this.$axios.post("testimonial/get.php" , {
                pageSize: this.pagination.perPageItem,
                page: this.pagination.currentPage
            },{
                headers: generateHeader("testimonialData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.table.tableData = response.data.body
                    this.pagination.totalData = parseInt(response.data.extra.totalData)
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.table.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.table.loading = false
            })
        },
        submitData(){
            this.handleFormValid("testimonialForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("testimonial/add.php", {
                    data: this.page.form
                }, {
                    headers: generateHeader("testimonialAdd")
                })
                .then((response) => {
                    if(response.data.code == "201"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('testimonialForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                   
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
            
        },
        updateData() {
            this.handleFormValid("testimonialForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("testimonial/update.php", {
                    data: this.page.form
                }, {
                    headers: generateHeader("testimonialEdit")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('testimonialForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                    
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        //Single row Delete
        handleDelete(index, row) {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('testimonial/delete.php' , {
                    id: row.t_id
                }, {
                    headers: generateHeader("testimonialDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
            })
        },
        // Bluk Delete
        blukDelete() {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('testimonial/bulk-delete.php' , {
                    data: this.table.multipleSelection
                }, {
                    headers: generateHeader("testimonialBulkDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
                this.$notify.info({
                    title: 'Info',
                    message: "Delete Cancle !!!"
                });
            })
        },
        resetData(formName){
            this.$refs[formName].resetFields();

            this.page.form.t_id = 0
            this.page.form.name = ''
            this.page.form.testimonial = ''
            this.page.form.rate= null

            this.page.formBtnSubmit = true
            this.page.formBtnUpdate = false
            this.page.formValid = false
        }
    },
    mounted() {
        this.getRights()
    }
}

</script>


<style>
    .el-rate{
        line-height: 40px !important;
        font-size: 50px;
    }
</style>